import React, { ComponentType } from 'react';
import { TranslationProvider } from './TranlationProvider';

const componentWithTranslation = <P extends object>(
  WrappedComponent: ComponentType<P>
) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const withTranslationHOC: React.FC<P> = (props: any) => {
    // Render the wrapped component with modified props
    return (
      <TranslationProvider data={props?.t || {}}>
        <WrappedComponent {...props} />
      </TranslationProvider>
    );
  };

  return withTranslationHOC;
};

export default componentWithTranslation;
